import React from "react";

import UserAccountsDetailComp from "./UserAccountDetailComp";

const UserAccountDetail =(props)=>{

    console.log(props.data);
    return (
        <div className="panel">
            <div className="panel-header">
                <div className="panel-header-label">Account Detail</div>
            </div>
            <UserAccountsDetailComp mode="view" data={props.data} />
            <div className="panel-footer">
                <div className="form-status"></div>
                <div className="btn-group">
                    <button
                        type="button"
                        className="btn btn-primary-outline"
                        onClick={props.handleClose}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default UserAccountDetail;